import React from "react";

import { Main, Bold } from "../styles";

export default function Answer() {
  return (
    <Main>
      <Bold as="h1" style={{ fontSize: 22 }} color="#4B4B4B">
        Documentação do veículo e do produto transportado
      </Bold>
      <Bold className="mt-3" color="#000FFF">
        Documentação específica para transporte fracionado (envasado)
      </Bold>
      <p>
        A - CCTPPF – IPEM/SP: Certificado de Capacitação para o Transporte de
        Produto Perigoso Fracionado: O CCTPPF é exigido pelo IPEM/SP quando se
        tratar de veículos de qualquer Estado da Federação que efetuar o
        transporte de GLP (ONU 1075) fracionado no Estado de São Paulo.
        Transitou nas vias do Estado de São Paulo será exigido o CCTPPF –
        IPEM/SP.
      </p>
      <Bold className="mt-3" color="#000FFF">
        Documentação geral
      </Bold>
      <p>
        A - CRLV: Certificado de Registro e Licenciamento do Veículo; CRLV
        distintos quando houver cavalo mecânico e carreta.
      </p>
      <p>
        B - Documento Fiscal (na saída) com dados obrigatórios: nº ONU precedido
        das letras UN ou ONU, nome apropriado para embarque e grupo de embalagem
        (para os produtos ONU 1011, ONU 1075 e ONU 1978 não há grupo de
        embalagem); Declaração do expedidor.
      </p>
      <p>C - Ficha de Emergência do produto transportável (Desejável).</p>
      <p>
        D - PAE (plano de ação emergencial) em formato resumido – obrigatório
        para o transporte de produtos e/ou resíduos perigosos que utilizem as
        vias públicas do estado de Minas Gerais.
      </p>
      <p>
        E - Ficha de características do tanque: Informações sobre o tanque:
        documento contendo características de fabricação, quantidade e
        localização das válvulas e pressão da válvula de alívio – obrigatório
        para o transporte dentro do estado de Minas Gerais (preferencialmente
        anexo ao PAE).
      </p>
      <p>
        F - Autorização para o transporte de carga em veículos de terceiros (Lei
        Complementar nº 121 de 09/02/2006).: Para cada veículo, autorização
        (original, em papel timbrado da empresa transportadora, assinada pelo
        responsável ou preposto) constando as seguintes informações: 1) Nome da
        empresa, constante no certificado de propriedade do veículo, 2)
        Endereço, 3) CNPJ, 4) Pessoa(s) autorizada(s) (Nome Completo, RG, nº
        Registro CNH), 5) Veículo que está sendo autorizado pela empresa
        proprietária (Marca, modelo, ano, cor, RENAVAN, chassis, placa, frota),
        6) Prazo: referenciar prazo indeterminado.
      </p>
      <p>
        G - Certificado de Aferição do Cronotacógrafo: Possui o Certificado de
        Aferição do Cronotacógrafo e se está válido. Exigido para veículos com
        PBT (peso bruto total) superior a 4,536 t e para veículos fabricados até
        1990 com PBT acima de 19 t.
      </p>
      <p>
        H - LETPP – Licença Especial de Trânsito de Produtos Perigosos, expedida
        pelo DSV: SOMENTE PARA TRÂNSITO PELO MUNICÍPIO DE SÃO PAULO/SP –
        validade de um ano- Deve citar o nº ONU 1075 (para os veículos
        conjugados ou articulados o caminhão trator não tem a LETPP, apenas o
        semirreboque ou reboque que este está tracionando).{" "}
      </p>
      <p>
        I - AATIPP – Autorização Ambiental de Transporte Interestadual de
        Produtos Perigosos: SOMENTE TRÂNSITO INTERESTADUAL – cada veículo deve
        ser detentor da AATIPP – Deve citar as classes dos produtos a serem
        transportados e as placas dos veículos.
      </p>
      <p>
        J - Licença ambiental de transporte intraestadual do órgão ambiental
        estadual - SOMENTE quando o transporte tiver origem e destino no mesmo
        Estado.
      </p>
      <p>
        K - Certificado de Regularidade: Certificado de Regularidade do Cadastro
        Técnico Federal de Atividades Potencialmente Poluidoras e Utilizadoras
        de Recursos Ambientais. Apresentação obrigatória do Documento físico
        para frota própria Ultragaz e opcional para as demais transportadoras.
      </p>
    </Main>
  );
}
